

















import { Component, Vue } from "vue-property-decorator";
import VueGallerySlideshow from 'vue-gallery-slideshow';

//import Lightbox from 'vue-pure-lightbox';
/*import HelloWorld from "@/components/HelloWorld.vue"; 
import HelloI18n from "@/components/HelloI18n.vue";*/
//import Lightbox from "@/lightbox";

@Component({
  components: {
    VueGallerySlideshow
  }
})
export default class Zipolite extends Vue {
	data() {
		return {
			images: [
				'/img-lightbox/1.jpg',
				'/img-lightbox/2.jpg',
				'/img-lightbox/3.jpg',
				'/img-lightbox/4.jpg',
				'/img-lightbox/5.jpg',
				'/img-lightbox/6.jpg',
				'/img-lightbox/7.jpg',
				'/img-lightbox/8.jpg',
				'/img-lightbox/9.jpg',
				'/img-lightbox/10.jpg',
				'/img-lightbox/11.jpg',
				'/img-lightbox/12.jpg',

			],
			index: null,
			
		};
	}
	
	
}
